import { createElement, forwardRef } from "react";
import { m, useReducedMotion } from "framer-motion";
import { getTransition, resolveVariant, variants } from "../../../utils/motionVariants";
import { getMotionComponent, resolveTag } from "./motionPrimitives";

/**
 * Stagger child — no own IntersectionObserver. Pair with MotionStagger.
 */
const MotionItem = forwardRef(function MotionItem(
  { as = "div", variant = "fadeUp", delay = 0, className, children, ...props },
  ref
) {
  const reduceMotion = useReducedMotion();
  const tag = resolveTag(as);
  const variantKey = resolveVariant(variant);
  const motionVariants = variants[variantKey] || variants.fadeUp;

  if (reduceMotion) {
    return createElement(tag, { ref, className, ...props }, children);
  }

  const Component = getMotionComponent(m, tag);

  return createElement(
    Component,
    {
      ref,
      variants: motionVariants,
      transition: getTransition(delay),
      className,
      ...props,
    },
    children
  );
});

MotionItem.displayName = "MotionItem";

export default MotionItem;
